import { render, staticRenderFns } from "./LogsTableOCPP.vue?vue&type=template&id=abcdf726&scoped=true&"
import script from "./LogsTableOCPP.vue?vue&type=script&lang=js&"
export * from "./LogsTableOCPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcdf726",
  null
  
)

export default component.exports